import React from "react";
import { AppContext } from "../../components/AppContext";
import InputText from "../../components/FormComponents/InputText";
// resources
import logo from "../../img/logo.svg";
import "./Payments.scss";
import { withTranslation } from "react-i18next";

class DiscountedLicense extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.state = {
            licenses: 1,
        };
    }

    componentDidMount() {
        var stripe = window.Stripe("pk_live_kwIdpEM2Jd5dZHiF4XINafHU00VDDmg2oX");

        var checkoutButton = document.getElementById("checkout-button-plan_GrBpwBhSfCw9N7");
        checkoutButton.addEventListener("click", () => {
            // When the customer clicks on the button, redirect
            // them to Checkout.
            console.log(this.state.licenses);
            stripe
                .redirectToCheckout({
                    items: [
                        {
                            plan: "plan_GrBpwBhSfCw9N7",
                            quantity: parseInt(this.state.licenses, 10),
                        },
                    ],

                    // Do not rely on the redirect to the successUrl for fulfilling
                    // purchases, customers may not always reach the success_url after
                    // a successful payment.
                    // Instead use one of the strategies described in
                    // https://stripe.com/docs/payments/checkout/fulfillment
                    successUrl: "http://app.optiwe.com/payments/success",
                    cancelUrl: "http://app.optiwe.com/payments/canceled",
                })
                .then(function (result) {
                    if (result.error) {
                        // If `redirectToCheckout` fails due to a browser or network
                        // error, display the localized error message to your customer.
                        var displayError = document.getElementById("error-message");
                        displayError.textContent = result.error.message;
                    }
                });
        });
    }

    handleChange(evt) {
        console.log(evt.target.name);
        console.log(evt.target.value);
        this.setState({ [evt.target.name]: evt.target.value });
    }

    render() {
        return (
            <div className="section-login">
                <div className="section-login__logo">
                    <h1>
                        <img src={logo} alt="Optiwe logo" />
                        <span className="d-none">Optiwe</span>
                    </h1>
                    <p>{this.props.t("payments.paymentSystem")}</p>
                </div>
                <div className="section-login__form">
                    <p>{this.props.t("payments.discountedLicenceText")}</p>
                    <div>
                        <p>Number of licenses</p>
                        <InputText
                            type="number"
                            name="licenses"
                            onChange={this.handleChange}
                            value={this.state.licenses}
                            placeholder="Number of licenses..."
                        />
                    </div>
                    <button
                        className="opt-button"
                        id="checkout-button-plan_GrBpwBhSfCw9N7"
                        role="link"
                    >
                        {this.props.t("payments.checkout")}
                    </button>
                </div>
            </div>
        );
    }
}
DiscountedLicense.contextType = AppContext;
export default withTranslation()(DiscountedLicense);
